import React, { useState, useEffect, Fragment } from 'react'
import { CheckMark, FlexContainer, Paragraph, XMark } from 'heliocor-ui'
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components'
import 'styled-components/macro'

import { WithTransition } from '../animations/WithTransition'
import { WarningBox } from '../WarningBox'

const Container = styled.div`
    position: relative;
    margin: ${props => props.margin};
    width: 16rem;
    max-width: 16rem;
    cursor: pointer;
    overflow: hidden;
    height: 16rem;
    & > div {
        will-change: transform, opacity;
        width: 100%;
        height: fit-content;
    }
    img {
        width: 260px;
    }
`

const ImgBg = styled.div(({
    theme:{ colors }, src, width, height, modal, noPadding
}) => css`
    width: ${width || 'fit-content'};
    height: ${height || 'fit-content'};
    background-image: url(${src});
    background-repeat: no-repeat;
    background-size: ${modal ? 'cover' :'contain'};
    background-position: center;
    background-color: ${colors.grey700};
    background-origin: content-box;
    padding: ${ noPadding ? '0' : '.5rem'};
`)

const NoPreview = styled.div(({
    theme:{ colors }
}) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 16rem;
    height: 16rem;
    text-align: center;
    background-color: ${colors.grey700};
    font-size: 14px;
`)

const Carousel = ({images}) => {

    const { t } = useTranslation()
    const [index, setIndex] = useState(0)
    const [modalIsOpen, openModal] = useState(false)
    const [selected, setSelected] = useState()

    const contentArray = images.map((img, i) => {
        
        if(img.type === "application/pdf") {
            return ({
                component: NoPreview,
                props: {
                    children: (
                        <React.Fragment>
                            <CheckMark fill='aqua100' size='32' />
                            <Paragraph margin="1rem 2rem 0 2rem" value={t('documentUploaded')} />
                            <Paragraph margin="0 2rem" value={t('documentNoPreview')} />
                        </React.Fragment>
                    )
                }
            })
        }

        
        return ({
            component: ImgBg,
            props:{
                width: '16rem',
                height: '16rem',
                src: img.src,
                onClick: () => {
                    setSelected(img.src)
                    openModal(true)
                }
            }
        })
    })

    useEffect(() => {
        if(contentArray.length > 1){
            const timer = setTimeout(() => {
                setIndex(index === images.length - 1 ? 0 : index + 1)
            }, 4000)
        return () => clearTimeout(timer)
    }}, [index, images, contentArray.length])

    return(
        <Fragment>
            <Container margin='2rem 1rem'>
                {WithTransition(contentArray, index)}
            </Container> 
            <WarningBox
                noTitle
                content={<img css='height: 70vh;' src={selected} alt='img'/>}
                onClose={() => openModal(false)}
                open={modalIsOpen}
                adornment={{
                    top: <FlexContainer 
                            css='cursor: pointer;' 
                            onClick={() => openModal(false)}  
                            padding='1rem 1.5rem' 
                            justifyContent='flex-end'
                        >
                            <XMark size='12' color='main'/>
                        </FlexContainer>
                }}
            />
        </Fragment>
    )

}

export { Carousel, ImgBg }